import React from 'react'
import styled from 'styled-components'
import * as constants from '../../../../../static/constants'
import SvgIcon from 'components/atoms/SvgIcon'

// 今後貸切予約の扱いができるようになったら改修する
export const PrivateGroupOption: React.VFC = () => {
  return (
    <PrivateGroupOptionWrapper>
      <div className="contact_info">
        <div>
          <SvgIcon name="lock_alt" className="icon" ariaHidden={true} role="presentation" />
          <span>Private Group Travel</span>
        </div>
        <p>If you want to book just for you and your group, contact us.</p>
      </div>
      <a
        href={constants.DMC_LINK + '/contact'}
        className="link_button"
        target="_blank"
        rel="noreferrer"
      >
        Contact
      </a>
    </PrivateGroupOptionWrapper>
  )
}

const PrivateGroupOptionWrapper = styled.div`
  width: 100%;
  // max-width: 544px;
  border-top: 1px solid ${constants.COLORS.divider2};
  border-bottom: 1px solid ${constants.COLORS.divider2};
  padding: 24px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media (max-width: ${constants.BREAKPOINT_TABLET_LARGE}px) {
    max-width: unset;
  }
  @media (max-width: ${constants.BREAKPOINT_TABLET_MOBILE}px) {
    padding: 1.6rem 0;
  }

  .contact_info {
    display: inline-flex;
    flex-direction: column;
    gap: 0.8rem;
    @media (max-width: ${constants.BREAKPOINT_TABLET_MOBILE}px) {
      gap: 0.4rem;
    }
    .icon {
      color: ${constants.COLORS.primary};
      margin-right: 0.8rem;
      @media (max-width: ${constants.BREAKPOINT_TABLET_MOBILE}px) {
        width: 2rem;
        height: 2rem;
      }
    }
    span {
      font-size: 1.6rem;
      font-weight: bold;
      @media (max-width: ${constants.BREAKPOINT_TABLET_MOBILE}px) {
        font-size: 1.4rem;
      }
    }
    p {
      font-size: 1.4rem;
      margin-right: 1.6rem;
      @media (max-width: ${constants.BREAKPOINT_TABLET_MOBILE}px) {
        font-size: 1.2rem;
        margin-right: 0.8rem;
      }
    }
  }
  .link_button {
    line-height: 2.4rem
    font-size: 1.6rem;
    font-weight: bold;
    padding: 0.8rem 2rem;
    border: 1px solid ${constants.COLORS.primary};
    border-radius: 2rem;
    color: ${constants.COLORS.primary};
    text-decoration: none;
    transition: background-color .2s, color .2s;
    @media (max-width: ${constants.BREAKPOINT_TABLET_MOBILE}px) {
      padding: 0.8rem 1.6rem;
      font-size: 1.4rem;
    }
    &:hover {
      color: ${constants.COLORS.white};
      background-color: ${constants.COLORS.primary};
    }
  }
`
